export default __webpack_public_path__ + "static/media/MINUT.03c6756d.png";